//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  props: {
    width: {
      type: String,
      "default": '400px'
    },
    centered: {
      type: Boolean,
      "default": false
    },
    overlay: {
      type: Boolean,
      "default": true
    },
    'text-center': {
      type: Boolean,
      "default": false
    },
    title: {
      type: String,
      "default": 'Modal'
    },
    'title-class': {
      type: String,
      "default": ''
    },
    'hide-header': {
      type: Boolean,
      "default": false
    },
    'hide-footer': {
      type: Boolean,
      "default": false
    },
    'ok-title': {
      type: String,
      "default": 'Ok'
    },
    'ok-disabled': {
      type: Boolean,
      "default": false
    },
    'ok-class': {
      type: String,
      "default": ''
    },
    'hide-ok': {
      type: Boolean,
      "default": false
    },
    'ok-loading': {
      type: Boolean,
      "default": false
    },
    'cancel-title': {
      type: String,
      "default": 'Cancel'
    },
    'cancel-disabled': {
      type: Boolean,
      "default": false
    },
    'cancel-class': {
      type: String,
      "default": ''
    },
    'hide-cancel': {
      type: Boolean,
      "default": false
    },
    'no-close-on-backdrop': {
      type: Boolean,
      "default": false
    },
    'no-close-on-esc': {
      type: Boolean,
      "default": false
    },
    error: {
      type: Boolean,
      "default": false
    },
    success: {
      type: Boolean,
      "default": false
    }
  },
  mounted: function mounted() {
    var this$1 = this;
    window.addEventListener('keyup', function (e) {
      return this$1.esc(e);
    });
  },
  beforeDestroy: function beforeDestroy() {
    var this$1 = this;
    window.removeEventListener('keyup', function (e) {
      return this$1.esc(e);
    });
  },
  data: function data() {
    return {
      opened: false
    };
  },
  computed: {
    btnLoading: function btnLoading() {
      return this.okLoading ? 'vm-btn-loading' : '';
    }
  },
  methods: {
    open: function open() {
      this.$emit('open');
      this.opened = true;
    },
    hide: function hide() {
      this.$emit('hide');
      this.opened = false;
    },
    backdrop: function backdrop() {
      if (!this.noCloseOnBackdrop) {
        this.hide();
      }
    },
    esc: function esc(e) {
      if (!this.noCloseOnEsc && e.which === 27) {
        this.hide();
      }
    },
    ok: function ok(e) {
      if (this.okLoading) {
        return;
      } else {
        this.$emit('ok', e);
      }
    },
    cancel: function cancel(e) {
      this.$emit('cancel', e);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';

      if (css.media) {
        style.element.setAttribute('media', css.media);
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;

      if (nodes[index]) {
        style.element.removeChild(nodes[index]);
      }

      if (nodes.length) {
        style.element.insertBefore(textNode, nodes[index]);
      } else {
        style.element.appendChild(textNode);
      }
    }
  }
}

var browser = createInjector;
/* script */

var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [_vm.opened ? _c('div', {
    staticClass: "vue-modality",
    "class": {
      'vm-centered': _vm.centered,
      'vm-overlay': _vm.overlay
    },
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.backdrop($event);
      },
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.esc($event);
      }
    }
  }, [_c('div', {
    staticClass: "vue-modality-dialog",
    "class": {
      'margintop': !_vm.centered
    },
    style: "width: " + _vm.width
  }, [!_vm.hideHeader ? _c('header', [_c('span', {
    staticClass: "vm-close-btn",
    on: {
      "click": _vm.hide
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vm-header",
    "class": {
      'vm-header-border': _vm.title.length > 0
    }
  }, [_c('span', {
    "class": _vm.titleClass
  }, [_vm._v(_vm._s(_vm.title))])])]) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "vm-body",
    "class": {
      'vm-text-center': _vm.error || _vm.success || _vm.textCenter
    }
  }, [_vm.error ? _c('div', {
    staticClass: "vm-icon vm-error-icon"
  }, [_c('div', {
    staticClass: "vm-inner-error-icon"
  })]) : _vm._e(), _vm._v(" "), _vm.success ? _c('div', {
    staticClass: "vm-icon vm-success-icon"
  }, [_c('span', {
    staticClass: "vm-inner-success-icon"
  }, [_c('div', {
    staticClass: "vm-success-stem"
  }), _vm._v(" "), _c('div', {
    staticClass: "vm-success-kick"
  })])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), !_vm.hideFooter ? _c('footer', {
    staticClass: "vm-footer"
  }, [!_vm.hideCancel ? _c('button', {
    staticClass: "vm-btn vm-cancel-btn",
    "class": _vm.cancelClass,
    attrs: {
      "disabled": _vm.cancelDisabled || _vm.okLoading
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.cancel($event);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.cancelTitle) + "\n                ")]) : _vm._e(), _vm._v(" "), !_vm.hideOk ? _c('button', {
    staticClass: "vm-btn vm-ok-btn",
    "class": [_vm.okClass, _vm.btnLoading],
    attrs: {
      "disabled": _vm.okDisabled
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.ok($event);
      }
    }
  }, [!_vm.okLoading ? _c('span', [_vm._v(_vm._s(_vm.okTitle))]) : _vm._e(), _vm._v(" "), _vm.okLoading ? _c('div', {
    staticClass: "vm-loader"
  }) : _vm._e()]) : _vm._e()]) : _vm._e()])]) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) {
    return;
  }

  inject("data-v-1e4e7f54_0", {
    source: "@import url(https://fonts.googleapis.com/css?family=Open+Sans&display=swap);.vue-modality{font-family:\"Open Sans\",sans-serif;color:#555;font-size:14px;overflow:hidden;line-height:1.42857143;position:fixed;height:100%;width:100%;overflow:auto;top:0;left:0;display:flex;z-index:9999;justify-content:center}@media (max-width:660px){.vue-modality-dialog{width:96%!important;height:98%!important}}.vue-modality-dialog{position:absolute;min-height:100px;max-height:100vh;overflow:auto;background:#fff;border-radius:3px;box-shadow:0 1px 3px rgba(0,0,0,.2);padding:12px 15px;display:flex;flex-direction:column}.vm-overlay{background:rgba(0,0,0,.3)}.vm-centered{align-items:center}.vm-start{padding-top:10px;align-items:flex-start}.vm-close-btn{position:absolute;cursor:pointer;top:16px;right:16px;width:16px;height:16px;z-index:9999;opacity:.6}.vm-close-btn:hover{opacity:1}.vm-close-btn:after,.vm-close-btn:before{position:absolute;content:'';height:2px;width:100%;top:50%;left:0;margin-top:-1px;background:#535353;border-radius:100%}.vm-close-btn:before{transform:rotate(45deg)}.vm-close-btn:after{transform:rotate(-45deg)}.vm-btn-loading{opacity:.6;cursor:default!important}.vm-header{font-weight:700;font-size:16px;padding-bottom:10px}.vm-header-border{border-bottom:1px solid #e9e9e9}.vm-body{padding:16px 0;flex:1}.vm-footer{border-top:1px solid #e9e9e9;padding:13px 0 0 0;display:flex;justify-content:flex-end}.vm-btn{padding:.3rem .75rem;border-radius:2px;text-align:center;text-decoration:none;display:inline-block;margin-left:6px;border:0;transition:all .4s ease;cursor:pointer;font:inherit!important}.vm-btn:hover{opacity:.6}.vm-btn:disabled{background:#c1c1c1;cursor:default}.vm-btn:disabled:hover{opacity:1}.vm-ok-btn{margin-left:6px;border:0;background-color:#2a6ec3;color:#fff}.vm-cancel-btn{background-color:grey;color:#fff}.vm-text-center{text-align:center}.margintop{margin-top:10px}.modal-fade-enter,.modal-fade-leave-active{opacity:0}.modal-fade-enter-active,.modal-fade-leave-active{transition:opacity .5s ease}.vm-icon{width:60px;height:60px;border-radius:50%;background-color:#fff;position:relative;overflow:hidden;display:block;margin:0 auto;box-sizing:border-box}.vm-error-icon{border:4px solid #e06565;margin-bottom:12px;color:#e06565}.vm-inner-error-icon:after{position:relative;display:inline-block;content:\"\\D7\";left:1px;bottom:24px;font-size:68px;animation-name:jump;animation-duration:.9s}@keyframes jump{0%{bottom:24px}40%{bottom:36px}60%{bottom:24px}80%{bottom:30px}100%{bottom:24px}}.vm-success-icon{border:4px solid #29af18;margin-bottom:12px}.vm-inner-success-icon{display:inline-block;width:40px;height:40px;transform:rotate(45deg)}.vm-success-stem{position:absolute;width:4px;height:32px;background-color:#29af18;left:30px;top:7px;border-radius:2px;animation-name:stem;animation-duration:.4s}@keyframes stem{0%{height:0;top:32px}49%{height:0;top:32px}100%{height:32px;top:7px}}.vm-success-kick{position:absolute;width:18px;height:4px;background-color:#29af18;left:15px;top:36px;border-radius:2px;animation-name:kick;animation-duration:1s}@keyframes kick{0%{width:3px}48%{width:18px}100%{width:18px}}.vm-loader{border:2px solid transparent;border-top:2px solid #f9f9f9;border-right:2px solid #f9f9f9;border-bottom:2px solid #f9f9f9;border-radius:50%;width:14px;height:14px;animation:spin 1s linear infinite}@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

var component = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, browser, undefined);

function install(Vue) {
  if (install.installed) {
    return;
  }

  install.installed = true;
  Vue.component("VueModality", component);
}

var plugin = {
  install: install
};
var GlobalVue = null;

if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue = global.vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

component.install = install;
export default component;